const MIME_BY_EXTENSION: Record<string, string> = {
	png: "image/png",
	svg: "image/svg+xml",
	ico: "image/x-icon",
	jpg: "image/jpeg",
	jpeg: "image/jpeg",
	gif: "image/gif",
	webp: "image/webp",
};

const DEFAULT_MIME = "image/x-icon";

const inferMimeFromHref = (href: string): string => {
	const match = href.toLowerCase().match(/\.([a-z0-9]+)(?:\?.*)?$/);

	if (!match) return DEFAULT_MIME;

	return MIME_BY_EXTENSION[match[1]] ?? DEFAULT_MIME;
};

/**
 * Injects a favicon link into the <head> of the document, replacing any
 * existing favicon link. When `type` is omitted the MIME type is inferred
 * from the href extension; pass `type` explicitly to override.
 */
export const injectFavicon = (href: string, type?: string) => {
	const existingLinks = document.head.querySelectorAll('link[rel~="icon"]');

	existingLinks.forEach((link) => {
		link.remove();
	});

	const newLink = document.createElement("link");

	newLink.rel = "icon";
	newLink.type = type ?? inferMimeFromHref(href);
	newLink.href = href;

	document.head.appendChild(newLink);
};
